// (window as any).global.ng = window;
// (window as any).process = {
//   env: { DEBUG: undefined },
// };
